import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Typography, Grid, Box, TextField } from '@mui/material';
import dayjs from 'dayjs';

const CustomDatePicker = ({ displayText, value, onChange, minDate }) => {
    const handleDateChange = (date) => {
        if (date) {
            const formattedDate = dayjs(date).format('YYYY-MM-DD');
            onChange(formattedDate);
        } else {
            onChange(null);
        }
    };

    // Ensure the value being passed to DatePicker is a valid Dayjs object or null
    const dayjsValue = value ? dayjs(value) : null;
    const dayjsMinDate = minDate ? dayjs(minDate) : null;
    const dayjsMaxDate = dayjs(); // Set maxDate to today by default

    const widthDate = displayText !== null ? 8 : 12;

    return (
        <Grid container justifyContent="center" sx={{ marginY: 1 }}>
            {displayText && (
                <Grid item xs={4}>
                    <Typography variant="subtitle1" component="div" sx={{ textAlign: "center" }}>
                        {displayText}
                    </Typography>
                </Grid>
            )}
            <Grid item xs={widthDate}>
                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={dayjsValue}
                            onChange={handleDateChange}
                            minDate={dayjsMinDate}
                            maxDate={dayjsMaxDate} // Use today's date as the maximum
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </LocalizationProvider>
                </Box>
            </Grid>
        </Grid>
    );
};

export default CustomDatePicker;
